export async function to (promise): Promise<Record<string, any>[]> {
  try {
    const result = await promise

    return [null, result]
  } catch (err) {
    return [err, null]
  }
}
